module.exports = require("@translate-tools/core/translators/GoogleTranslator");